import { Box, Skeleton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AutoGraph } from "@mui/icons-material";
import { evaluatePriceCategory, formatCurrency, getChartColor } from "./energyUtils";
import { isEmpty } from "lodash";

const PriceIndicator = ({ plan, onClickPlan, loading }) => {
  const [color, setColor] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [exportColor, setExportColor] = useState("");

  useEffect(() => {
    if (!isEmpty(plan)) {
      if (plan?.price_import) {
        setColor(
          getChartColor(evaluatePriceCategory(plan.price_import, "price_import"))
        );
        setBgColor(
          getChartColor(
            evaluatePriceCategory(plan.price_import, "price_import"),
            true,
            0.05
          )
        );
      }

      if (plan?.price_export) {
        setExportColor(
          getChartColor(evaluatePriceCategory(plan.price_export, "price_export"))
        );
      }
    }
  }, [plan]);

  if (loading || isEmpty(plan)) {
    return (
      <Skeleton className="price-indicator-loading" width="100px" height="60px" />
    );
  }

  return (
    <Box
      className="price-indicator"
      sx={{
        border: `2px solid ${color}`,
        backgroundColor: bgColor,
        width: "100px",
        minHeight: "58px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        cursor: "pointer",
      }}
      onClick={!loading && onClickPlan && onClickPlan}
    >
      <Box
        className="items-center"
        sx={{ color, display: "flex", alignItems: "center" }}
      >
        <Typography
          className="price_import"
          fontSize="22px"
          variant="h3"
          lineHeight={1.2}
        >
          {formatCurrency(plan?.price_import)}
        </Typography>
      </Box>
      <Typography fontSize="11px" lineHeight={1} align="center">
        {!onClickPlan && <span>current price</span>} per kWh
      </Typography>
      {onClickPlan ? (
        <Box
          className="items-center"
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <AutoGraph fontSize="11px" />
          <Typography fontSize="11px" lineHeight={1} align="center" fontWeight={500}>
            view plan
          </Typography>
        </Box>
      ) : (
        <Box
          className="items-center"
          sx={{
            color: exportColor,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography fontSize="14px" variant="h5" lineHeight={1.2}>
            Sell {formatCurrency(plan?.price_export)}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PriceIndicator;
